module.exports = __webpack_public_path__ + "static/teleco_20-3fac23c2a785178a656fafdae6aa7919.jpg";